import React, { Component } from "react";
import { Bar } from "react-chartjs-2";
import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { connect } from "react-redux";
import MediaQuery from "react-responsive";
import Select from "react-select";
import {
  Alert,
  Card,
  CardBody,
  CardHeader,
  Col,
  Collapse,
  Label,
  Row,
} from "reactstrap";
import { bindActionCreators } from "redux";
import { layout, messages, roles } from "../../../../common/constants";
import { formatHelper, selectorChart } from "../../../../common/helpers";
import { ExportCSV } from "../../../../components";
import { getSellsTopCategories as topCategoriesExport } from "../../../../service/dashboard";
import { getSellsTopCategories } from "../../../../store/dashboard/actions";
import { getStores } from "../../../../store/store/actions";
import { selectStoresForSelect } from "../../../../store/store/selector";
import { selectUserRole } from "../../../../store/user/selector";
import * as charts from "./_charts";
import { exportExcel } from "./excel";
class CardSellsTopCategories extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,
      showTopCategories: true,
      loadingExport: false,
      selectedStore: null,
    };
    this.handleObtainCategoriesExport =
      this.handleObtainCategoriesExport.bind(this);

    this.handleStoreChange = this.handleStoreChange.bind(this);
  }

  async handleStoreChange(value) {
    if (value == this.state.selectedStore) return;
    await this.setState({ selectedStore: value, page: 1 });
    let startDate = this.state.startDate;
    let endDate = this.state.endDate;
    if (startDate != null && endDate != null) {
      this.props.getSellsTopCategories({
        startDate: startDate._d,
        endDate: endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  async componentDidMount() {
    await this.props.getStores({ reset: true });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.stores.length == 0 && this.props.stores.length > 0) {
      this.setState({ selectedStore: this.props.stores[0] });
    }
  }

  handleDateChange(startDate, endDate) {
    this.setState({ startDate, endDate });

    if (startDate != null && endDate != null) {
      this.props.getSellsTopCategories({
        startDate: startDate._d,
        endDate: endDate._d,
        store: this.state.selectedStore.value,
      });
    }
  }

  performGetTopCategories(reset = false) {
    const { getSellsTopCategories } = this.props;

    getSellsTopCategories({
      startDate: this.state.startDate._d,
      endDate: this.state.endDate._d,
      reset,
    });
  }

  async handleObtainCategoriesExport() {
    this.setState({ loadingExport: true });
    const { startDate, endDate, selectedStore } = this.state;
    topCategoriesExport(
      this.state.startDate._d,
      this.state.endDate._d,
      this.state.selectedStore.value
    )
      .then((response) => {
        exportExcel(response.data.data, selectedStore, startDate, endDate);
      })
      .finally(() => {
        this.setState({ loadingExport: false });
      });
  }

  render() {
    const { startDate, endDate, loadingExport } = this.state;
    return (
      <div>
        <Card>
          <CardHeader
            onClick={() =>
              this.setState({
                showTopCategories: !this.state.showTopCategories,
              })
            }
          >
            <i className="icon-chart"></i>Ventas Top Categorias
          </CardHeader>
          <Collapse isOpen={this.state.showTopCategories}>
            <CardBody>
              <MediaQuery minDeviceWidth={768}>
                {(matches) => {
                  if (matches) {
                    return (
                      <Row className="mb-2">
                        <Col md="4">
                          <DateRangePicker
                            startDate={startDate}
                            startDateId="startDate"
                            endDate={endDate}
                            endDateId="endDate"
                            displayFormat={"DD/MM/YYYY"}
                            onDatesChange={({ startDate, endDate }) =>
                              this.handleDateChange(startDate, endDate)
                            }
                            focusedInput={this.state.focusedInput}
                            onFocusChange={(focusedInput) =>
                              this.setState({ focusedInput })
                            }
                            startDatePlaceholderText="Fecha Inicio"
                            endDatePlaceholderText="Fecha Fin"
                            small
                            isOutsideRange={() => false}
                            hideKeyboardShortcutsPanel
                            minimumNights={0}
                          />
                        </Col>
                        <Col md="5">
                          {(this.props.role == roles.SUPER_ADMIN ||
                            this.props.role == roles.ADMIN) && (
                            <Row>
                              <Col sm="4">
                                <Label className="mt-2">TIENDA:</Label>
                              </Col>
                              <Col sm="8">
                                <Select
                                  className="basic-single"
                                  classNamePrefix="select"
                                  isLoading={this.props.loadingStores}
                                  isSearchable={true}
                                  noOptionsMessage={() => {
                                    return messages.SELECT_NO_OPTIONS;
                                  }}
                                  placeholder=""
                                  options={this.props.stores}
                                  loadingMessage={() => {
                                    return messages.SELECT_LOADING;
                                  }}
                                  onChange={this.handleStoreChange}
                                  value={this.state.selectedStore}
                                  isDisabled={this.props.loadingStores}
                                />
                              </Col>
                            </Row>
                          )}
                        </Col>
                        <Col md="3">
                          {this.state.startDate && this.state.endDate ? (
                            <ExportCSV
                              disabled={loadingExport}
                              exportCSV={this.handleObtainCategoriesExport}
                              minWidth={layout.MD_MIN_WIDTH}
                            />
                          ) : null}
                        </Col>
                      </Row>
                    );
                  } else {
                    return (
                      <div>
                        <Row>
                          <Col md="5">
                            {(this.props.role == roles.SUPER_ADMIN ||
                              this.props.role == roles.ADMIN) && (
                              <Row>
                                <Col sm="4">
                                  <Label className="mt-2">TIENDA:</Label>
                                </Col>
                                <Col sm="8">
                                  <Select
                                    className="basic-single"
                                    classNamePrefix="select"
                                    isLoading={this.props.loadingStores}
                                    isSearchable={true}
                                    noOptionsMessage={() => {
                                      return messages.SELECT_NO_OPTIONS;
                                    }}
                                    placeholder=""
                                    options={this.props.stores}
                                    loadingMessage={() => {
                                      return messages.SELECT_LOADING;
                                    }}
                                    onChange={this.handleStoreChange}
                                    value={this.state.selectedStore}
                                    isDisabled={this.props.loadingStores}
                                  />
                                </Col>
                              </Row>
                            )}
                          </Col>
                        </Row>
                        <Row className="mt-2">
                          <Col md="12">
                            <DateRangePicker
                              startDate={startDate}
                              startDateId="startDate"
                              endDate={endDate}
                              endDateId="endDate"
                              displayFormat={"DD/MM/YYYY"}
                              onDatesChange={({ startDate, endDate }) =>
                                this.handleDateChange(startDate, endDate)
                              }
                              focusedInput={this.state.focusedInput}
                              onFocusChange={(focusedInput) =>
                                this.setState({ focusedInput })
                              }
                              startDatePlaceholderText="Fecha Inicio"
                              endDatePlaceholderText="Fecha Fin"
                              small
                              numberOfMonths={1}
                              isOutsideRange={() => false}
                              hideKeyboardShortcutsPanel
                            />
                          </Col>
                          <Col md="3">
                            {this.state.startDate && this.state.endDate ? (
                              <ExportCSV
                                disabled={loadingExport}
                                exportCSV={this.handleObtainCategoriesExport}
                                minWidth={layout.MD_MIN_WIDTH}
                              />
                            ) : null}
                          </Col>
                        </Row>
                      </div>
                    );
                  }
                }}
              </MediaQuery>
              <hr className="my-4" />
              {startDate != null && endDate != null ? (
                <Row>
                  <Col>
                    <Row>
                      <Col>
                        <Bar
                          data={charts.SellsTopCategoriesData(
                            this.props.topCategoriesData
                          )}
                          options={charts.SellsTopCategoriesOptions()}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col>
                    <Alert color="info">
                      Seleccione un rango de fechas para visualizar los datos
                    </Alert>
                  </Col>
                </Row>
              )}
            </CardBody>
          </Collapse>
        </Card>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { sellsTopCategories, total, pageSize, error, loading } =
    state.dashboard.sellsTopCategoriesList;

  return {
    topCategoriesData: selectorChart.selectChartData(
      sellsTopCategories,
      "name",
      "total",
      formatHelper.toTwoDecimal,
      total
    ),
    total,
    pageSize,
    error,
    loading,
    role: selectUserRole(state),
    stores: selectStoresForSelect(state),
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getSellsTopCategories,
      getStores,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CardSellsTopCategories);



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/CardSellsTopCategories/CardSellsTopCategories.js